import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { RlFile } from '../../file/shared/rl-file';
import { FormConfigService } from '../core/form-config.service';
import { FormComponent } from '../form/form.component';
import { FormButtonType, FormConfig } from '../shared/form-config-abstract';
import { SectionItem } from '../../../section/shared/section-item';
import { FormType } from '../shared/form-type.enum';
import { FileService } from '../../file/core/file.service';
import { CitationListsConfigurationService } from '../../../ajs-upgraded-providers';

@Component({
  selector: 'rl-edit-form',
  templateUrl: './edit-form.component.html',
  styleUrls: ['./edit-form.component.scss']
})
export class EditFormComponent implements OnInit, AfterViewInit {

  @Input() formType : FormType;
  @Input() type : 'new' | 'edit' = 'new';
  @Input() item : any;
  @Input() fromFile? : boolean = false;
  @Input() applyBeforeSave : (item : any) => void;
  @Output() onCancel = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();
  @Output() onAdd = new EventEmitter<SectionItem>();

  @ViewChild(FormComponent) form : FormComponent;

  busy : boolean = false;
  fileUploaded : boolean = false;
  editFormConfig : FormConfig<any>;
  licenseTypes : any[];

  constructor(private formConfigService : FormConfigService, private licenses : CitationListsConfigurationService,
    private fileService : FileService) { }

  ngOnInit(){
    this.editFormConfig = this.formConfigService.getConfig(this.formType);
    if(this.fromFile) (<any>this.licenses).citationListsConfiguration.$promise.then(res => this.licenseTypes = res.copyrightOptions);
  }

  ngAfterViewInit(): void {
    if(this.item){
      this.form.setFields(this.item);
    }
  }

  add(close? : boolean){
    if(!this.form.validate()) return;
    this.busy = true;
    if(!this.fromFile) return this.addItem();
    this.fileService.storeFile(this.item.file.amazonFileKey).subscribe(storedFile => this.addItem());
  }

  addItem(){    
    if(this.applyBeforeSave) this.item = this.applyBeforeSave(this.item);
    let section = this.item.sectionIndex;
    delete this.item.sectionIndex;
    this.setCopyrightDeclaration();
    this.form.save(this.item).subscribe(item => {
      (<any>item).sectionIndex = section;
      this.onAdd.emit(<SectionItem>item);
      this.form.reset();
      this.busy = false;
      if(close){
        this.onClose.emit();
      }
    });
  }

  setCopyrightDeclaration(){
    if(this.licenseTypes?.length == 1){
      this.item.licenseType = this.item.licenseType ? this.licenseTypes[0].code : undefined;
    }
  }

  save(){
    if(!this.form.validate()){
      return;
    }
    if(this.applyBeforeSave)this.applyBeforeSave(this.item);
    this.busy = true;
    this.form.save(this.item).subscribe(() => this.onClose.emit());
  }

  onfileUploaded(file : RlFile){
    this.fileUploaded = true;
    this.item.file = file.data();
    this.setDefaultLicenseType();
    this.form.setFields(this.item);
    //remove resource dropdown
    this.editFormConfig.fields = this.editFormConfig.fields.filter(f => f instanceof Array  || f.name !== 'citationId');
  }

  setDefaultLicenseType(){
    if(this.licenseTypes?.length == 1){
      this.item.licenseType = this.item.licenseType ? true : this.licenseTypes[0].defaultOption;
    }

    if(this.licenseTypes?.length > 1){
      this.item.licenseType = this.item.licenseType || (this.licenseTypes.find(l => l.defaultOption))?.code || this.licenseTypes[0].code;
    }    
  }
  
  onfileRemoved(){
    this.fileUploaded = false;
    this.item = {};
    //Object.assign(this.item, file.data());
    this.form.setFields(this.item);
  }

  showButton = (btn : FormButtonType) : boolean => this.editFormConfig?.buttons.indexOf(btn) > -1;
}
